<template>
  <div class="notification-toasters" v-if="notificacoes.length > 0">
    <ol>
      <transition-group name="slideinToaster">
        <li v-for="notificacao in notificacoes" :key="notificacao.index">
          <toaster :scope="notificacao" :config="config"></toaster>
        </li>
      </transition-group>
    </ol>
  </div>
</template>

<script>
import Toaster from '@/components/utilities/notifications/Toaster.vue'

export default {
  props: {
    config: {
      type: Array
    }
  },
  components: {
    Toaster
  },
  data () {
    return {
      notificacoes: []
    }
  },
  mounted () {

  },
  methods: {
    addNotificacoes ( data ) {
      const index = `${Date.now()}-${Math.random().toString(16).slice(2)}`
      data.index = index
      this.notificacoes.push(data)
      
      setTimeout(() => {
        this.removeNotificacoes(index)
      },10000)
    },
    removeNotificacoes ( id ) {
      const index = this.notificacoes.findIndex(k => k.index == id)
      if (index >= 0) {
        this.notificacoes.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .notification-toasters {
    width: calc(100vw - 112px);
    max-width: 420px;
    position: fixed;
    bottom: 28px;
    left: 84px;
    z-index: 12000;
    pointer-events: none;

    ol {
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 0;
      margin: 0;

      li {
        list-style: none;
        padding: 0;
        margin: 0;
        pointer-events: auto;
      }
    }
  }

  .slideinToaster-enter-active  {
    transition: transform .28s ease, opacity .28s ease;
  }

  .slideinToaster-leave-active {
    position: absolute;
    right: 0;
    left: 0;
    transition: transform .2s ease, opacity .2s ease;
  }

  .slideinToaster-move {
    transition: transform .24s ease;
  }

  .slideinToaster-enter-from {
    transform: translateY(18px) scale(.98);
    opacity: 0;
  }

  .slideinToaster-leave-to {
    transform: translateY(12px) scale(.98);
    opacity: 0;
  }

  @media (max-width: 700px) {
    .notification-toasters {
      width: auto;
      max-width: none;
      right: 16px;
      bottom: 16px;
      left: 16px;
    }
  }
</style>
